import { render, staticRenderFns } from "./NewsEditor.vue?vue&type=template&id=35a778f5&scoped=true&"
import script from "./NewsEditor.vue?vue&type=script&lang=js&"
export * from "./NewsEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewsEditor.vue?vue&type=style&index=0&id=35a778f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a778f5",
  null
  
)

export default component.exports